export const LIST = "UP_LEVEL_BONUS_LIST";
export const MEMBER_LEVEL_TRACKER_LIST = "UP_LEVEL_BONUS_MEMBER_LEVEL_TRACKER_LIST";
export const DROPDOWN = "UP_LEVEL_BONUS_DROPDOWN";